import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    flex: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
    status: {
      textTransform: 'uppercase',
      // not available in material-ui, should we add it?
      fontSize: '0.625rem',
      fontWeight: 500,
      borderRadius: '16px',
      padding: theme.spacing(0, 1),
      marginLeft: theme.spacing(),
    },
    statusNew: {
      backgroundColor: '#9E9E9E',
      color: theme.palette.common.white,
    },
    statusInProgress: {
      backgroundColor: '#FDD835',
      color: theme.palette.common.black,
    },
    statusCompleted: {
      backgroundColor: '#43A047',
      color: theme.palette.common.white,
    },
    dueDateSoon: {
      color: theme.palette.warning.main,
    },
    dueDatePast: {
      color: theme.palette.error.main,
    },
    title: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: 'auto',
      marginBottom: 'auto',
      marginRight: theme.spacing(1),
    },
    listItemRoot: {
      padding: '0px 8px',
    },
    listItemTextPrimary: {
      fontWeight: 500,
    },
    listItemTextEmployee: {
      fontSize: '0.82rem',
      color: 'black',
    },
  };
};
